<div class="breadcrumb">
  <!-- Back Button -->
  <div class="button-container" *ngIf="!hideBackButton">
    <button
      pButton
      pRipple
      type="button"
      icon="pi pi-arrow-circle-left"
      (click)="goBack()"
      class="p-button-rounded p-button-text"
    ></button>
  </div>

  <!-- Breadcrumb -->

  <div class="breadcrumb-items">
    <ng-container *ngFor="let item of items; let i = index; last as isLast">
      <div
        [ngClass]="{ link: !!item.routerLink, current: !!isLast }"
        (click)="navigateTo(item)"
      >
        <i [class]="item.icon"></i>
        <span>{{ item.label }}</span>
      </div>
      <ng-container *ngIf="!isLast">
        <i class="pi pi-angle-right"></i>
      </ng-container>
    </ng-container>
  </div>
</div>
